<template>
<div class="badge text-white">
    <div v-if="row.psp == 'mellat'">
        <img src="/assets/media/psp/mellat.png" width="32" height="32">
    </div>
    <div v-else-if="row.psp == 'parsian'">
        <img src="/assets/media/psp/parsian.svg" width="32" height="32">
    </div>
    <div v-else-if="row.psp == 'pasargad'">
        <img src="/assets/media/psp/pasargad.svg" width="32" height="32">
    </div>
    <div v-else-if="row.psp == 'saman'">
        <img src="/assets/media/psp/saman.svg" width="32" height="32">
    </div>
    <div v-else-if="row.psp == 'novin'">
        <img src="/assets/media/psp/novin.svg" width="32" height="32">
    </div>
    <div v-else-if="row.psp == 'sepehr'">
        <img src="/assets/media/psp/sepehr.png" width="32" height="32">
    </div>
    <div v-else-if="row.psp == 'irankish'">
        <img src="/assets/media/psp/irankish.png" width="32" height="32">
    </div>
    <div v-else-if="row.psp == 'asanpardakht'">
        <img src="/assets/media/psp/ap-logo.png" width="32" height="32">
    </div>
    <div v-else v-text="`_____`" style="color:#333;"></div>

</div>
</template>

<script>
import Vue from 'vue'
import { pspNameStr, pspNameVariant } from '@/constants/pspRequestStatus'
export default Vue.extend({
    props: {
        row: {
            required: true,
        },
        index: {
            required: true,
        },
        datatable: {
            required: true,
        }
    },
    computed: {
        psp() {
            return pspNameStr.get(this.row.psp)
        },
        variant() {
            return 'badge-'+pspNameVariant(this.row.psp)
        }
    },
})
</script>

<style>
    .badge-novin{
        color: #fff;
        background-color: #683f84;
    }
    .badge-mellat{
        color: #fff;
        background-color: #ed1b2f;
    }
    .badge-saman{
        color: #fff;
        background-color: #07abea;
    }
    .badge-pasargad{
        color: #fff;
        background-color: #f7a403;
    }
    .badge-sepehr{
      color: #fff;
      background-color: green;
    }
    .badge-parsian{
      color: #fff;
      background-color: #856012;
    }
    .badge-irankish {
      color: #fff;
      background-color: rgb(185, 17, 51);
    }
</style>